import { each } from 'underscore';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class BackboneInstanceWrapper extends Component {
  static defaultProps = {
    managed: false,
    eventHandlers: {
      once: {},
      on: {},
    },
  };

  static propTypes = {
    /**
     * an instance of backbone view
     */
    instance: PropTypes.shape({
      $el: PropTypes.object.isRequired,
      render: PropTypes.func.isRequired,
      off: PropTypes.func.isRequired,
      once: PropTypes.func.isRequired,
      on: PropTypes.func.isRequired,
    }).isRequired,
    /**
     * indicate if backbone view is managed outside
     */
    managed: PropTypes.bool,

    /**
     * Handlers to be triggered on backbone event
     */
    eventHandlers: PropTypes.shape({
      once: PropTypes.objectOf(PropTypes.func),
      on: PropTypes.objectOf(PropTypes.func),
    }),
  };

  componentDidMount() {
    this.mount();
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.instance !== this.props.instance;
  }

  componentDidUpdate() {
    this.detach();
    this.mount();
  }

  componentWillUnmount() {
    this.detach();
  }

  detach() {
    if (this.props.managed) {
      this.instance.$el.detach();
    } else {
      this.instance.undelegateEvents().off().remove();
    }
  }

  mount() {
    each(this.props.eventHandlers.once, (handler, event) => {
      this.props.instance.once(event, handler);
    });

    each(this.props.eventHandlers.on, (handler, event) => {
      this.props.instance.on(event, handler);
    });
    this.instance = this.props.instance;
    this.instance.$el.appendTo(this.container);
  }

  render() {
    return (<div className="ba-backbone-instance-wrapper" ref={(container) => { this.container = container; }} />);
  }
}
